import type { ReactNode } from "react";

export default function TaskTimelineRow({
  time,
  icon,
  active,
  completed = false,
  primaryColor,
  secondaryColor,
  currentTime,
  currentTimeProgress = 0,
  children,
}: {
  time: string;
  icon: ReactNode;
  active: boolean;
  completed?: boolean;
  primaryColor: string;
  secondaryColor: string;
  currentTime?: string;
  currentTimeProgress?: number;
  children: ReactNode;
}) {
  return (
    <div
      className={`task-timeline-row${active ? " active" : ""}${completed ? " completed" : ""}`}
      style={{
        "--timeline-primary": primaryColor,
        "--timeline-secondary": secondaryColor,
      } as React.CSSProperties}
    >
      <div className="timeline" aria-label={`${time}${active ? ", active" : ""}`}>
        <time>{time}</time>
        <span className="marker" aria-hidden="true">{icon}</span>
        <span className="line" aria-hidden="true">
          {currentTime && (
            <span
              className="current-time"
              style={{ "--current-time-progress": Math.min(1, Math.max(0, currentTimeProgress)) } as React.CSSProperties}
            >
              {currentTime}
            </span>
          )}
        </span>
      </div>
      <div className="content">{children}</div>
    </div>
  );
}

export function TimelineNowSeparator({ time }: { time: string }) {
  return (
    <div className="timeline-now-separator" aria-label={`Current time ${time}`}>
      <time>{time}</time>
      <span aria-hidden="true" />
    </div>
  );
}
